import { dispatchActionLabels, initialAccessSelection, accessOptions, changeAccessSelection, accessPayload } from './moduleAccessSelection';
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputSwitch } from 'primereact/inputswitch';
import { MultiSelect } from 'primereact/multiselect';
import { TabPanel, TabView } from 'primereact/tabview';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { handleGetRequest } from '../../service/GetTemplate';
import AddEditUser from './AddEditUser';
import ImpersonateUser from './ImpersonateUser';
import { endPoints } from '../../Config';
import { useDispatch } from 'react-redux';
import ActiveInactiveDialog from '../../components/ActiveInactiveDialog';
import { handlePatchRequest } from '../../service/PatchTemplate';import { Tag } from 'primereact/tag';
import usePreferredLanguage from '../../utilities/usePreferredLanguage';
import { translateUiText } from '../../utilities/siteTranslations';
import { Card } from 'primereact/card';


const Users = () => {
    const preferredLanguage = usePreferredLanguage();
    const t = (value) => translateUiText(value, preferredLanguage);
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [rowRecord, setRowRecord] = useState(null);
    const [allUsers, setAllUsers] = useState([]);
    const [editable, setEditable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const [switchData, setSwitchData] = useState(null);
    const [switchModal, setSwitchModal] = useState(false);
    const [accessMatrix, setAccessMatrix] = useState(null);
    const [accessUsers, setAccessUsers] = useState([]);
    const [accessAudit, setAccessAudit] = useState(null);
    const [accessLoadError, setAccessLoadError] = useState('');
    const [accessDialogVisible, setAccessDialogVisible] = useState(false);
    const [accessDialogUser, setAccessDialogUser] = useState(null);
    const [selectedModules, setSelectedModules] = useState([]);
    const [dispatchAccessChanged, setDispatchAccessChanged] = useState(false);
    const [accessDetailUser, setAccessDetailUser] = useState(null);
    const [accessSearch, setAccessSearch] = useState('');
    const [expandedTeamRows, setExpandedTeamRows] = useState(null);
    const [expandedModuleRows, setExpandedModuleRows] = useState(null);
    const [expandedAccessRows, setExpandedAccessRows] = useState(null);
    // const [loadingBtn, setLoadingBtn] = useState(false);

    // const permissionsList = useSelector((state) => state?.pagePermissions?.permissions || []);

    // const dt = React.useRef(null);
    const dispatch = useDispatch();
    const currentUser = JSON.parse(localStorage.getItem('userDetails') || '{}');
    const currentAdmin = currentUser?.data?.adminUser || {};
    const currentRoleUid = currentAdmin?.role?.uid;

    const handleAdd = () => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(false);
    };

    const handleEdit = (rowData) => {
        setShowAddDialog(true);
        setEditable(true);
        setViewable(false);
        setRowRecord(rowData);
    };

    const handleView = (rowData) => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(true);
        setRowRecord(rowData);
    };

    const onHide = () => {
        setShowAddDialog(false);
        getUserList();
    };
    const onClose = () => {
        setShowAddDialog(false);
    };

    const handleInputSwitch = async () => {
        // setLoadingBtn(true);

        let data = {
            userId: switchData?._id,
            isActive: switchData?.isActive ? false : true,
        };

        const response = await dispatch(handlePatchRequest(data, endPoints?.updateUserStatus, false, true));

        if (response?.status === 200) {
            getUserList();
        }

        // setLoadingBtn(false);
        handleSwitchModalClose();
    };

    const handleSwitchModalOpen = () => {
        setSwitchModal(true);
    };

    const handleSwitchModalClose = () => {
        setSwitchModal(false);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {' '}
                    <InputSwitch
                        tooltip={t('Status')}
                        tooltipOptions={{ position: 'top' }}
                        checked={rowData.isActive}
                        onChange={() => {
                            handleSwitchModalOpen();
                            setSwitchData(rowData);
                        }}
                    />
                    {/* {permissionsList?.updateAllowed === 'Y' && ( */}
                    <Button
                        tooltip={t('Edit')}
                        icon="pi pi-pencil"
                        tooltipOptions={{ position: 'top' }}
                        disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.status === 'N') ? true : false}
                        onClick={() => {
                            handleEdit(rowData);
                        }}
                        className="p-button-rounded p-button-primary mr-2 ml-2"
                    />
                    {/* )} */}
                    {/* {permissionsList?.viewAllowed === 'Y' && ( */}
                    <Button
                        tooltip={t('View')}
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        onClick={() => {
                            handleView(rowData);
                        }}
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />
                    {/* )} */}
                </div>
            </>
        );
    };

    const getUserList = async () => {
        const response = await handleGetRequest(endPoints.getallUsers, true, false, dispatch);
        if (response) {
            let users = response?.data || [];

            // Hide Super Admin rows from the table (admins can see other admins)
            users = users.filter((u) => {
                const roleUid = u.role?.uid;
                return roleUid !== 'superAdmin';
            });

            setAllUsers(users);
        }
    };

    const loadAccessData = async () => {
        const [matrixRes, usersRes, auditRes] = await Promise.all([
            handleGetRequest(endPoints.getAccessMatrix, true, false, dispatch),
            handleGetRequest(endPoints.getAccessUsers, true, false, dispatch),
            handleGetRequest(endPoints.getAccessAudit, true, false, dispatch)
        ]);

        let hasError = false;
        if (matrixRes && Object.prototype.hasOwnProperty.call(matrixRes, 'data')) setAccessMatrix(matrixRes.data || null);
        else hasError = true;
        if (usersRes && Object.prototype.hasOwnProperty.call(usersRes, 'data')) setAccessUsers(usersRes.data || []);
        else hasError = true;
        if (auditRes && Object.prototype.hasOwnProperty.call(auditRes, 'data')) setAccessAudit(auditRes.data || null);
        else hasError = true;
        setAccessLoadError(hasError ? t('Could not load access data. Please refresh and try again.') : '');
    };

    const openAccessDialog = (row) => {
        setAccessDialogUser(row);
        setSelectedModules(initialAccessSelection(row));
        setDispatchAccessChanged(false);
        setAccessDialogVisible(true);
    };

    const closeAccessDialog = () => {
        setAccessDialogVisible(false);
        setAccessDialogUser(null);
        setSelectedModules([]);
    };

    const saveAccessDialog = async () => {
        if (!accessDialogUser?._id) return;
        const payload = accessPayload(selectedModules, dispatchAccessChanged);
        const response = await dispatch(
            handlePatchRequest(payload, endPoints.updateUserAccess(accessDialogUser._id), false, true)
        );
        if (response?.status === 200) {
            window.dispatchEvent(new Event('supply-access-changed'));
            closeAccessDialog();
            loadAccessData();
        }
    };

    const resetAccessToRole = async () => {
        if (!accessDialogUser?._id) return;
        const payload = { moduleAccessOverride: null, supplyDispatchAccessOverride: null };
        const response = await dispatch(
            handlePatchRequest(payload, endPoints.updateUserAccess(accessDialogUser._id), false, true)
        );
        if (response?.status === 200) {
            window.dispatchEvent(new Event('supply-access-changed'));
            closeAccessDialog();
            loadAccessData();
        }
    };
  

    useEffect(() => {
        getUserList();
        loadAccessData();
    }, []);
    const statusBodyTemplate = (rowData) => {
        const isActive = rowData.isActive;

        return (
            <div className="flex justify-content-center">
                <Tag
                    value={isActive ? t('Active') : t('Inactive')}
                    severity={isActive ? 'success' : 'danger'}
                    className="px-3 py-1 text-xs border-round-lg"
                />
            </div>
        );
    };

    const normalizedAccessSearch = accessSearch.trim().toLowerCase();
    const filteredAccessUsers = accessUsers.filter((row) => {
        if (!normalizedAccessSearch) return true;
        return [row?.firstName, row?.lastName, row?.email, row?.roleUid, row?.teamName]
            .filter(Boolean)
            .join(' ')
            .toLowerCase()
            .includes(normalizedAccessSearch);
    });

    const teamRows = Object.values(
        accessUsers.reduce((groups, user) => {
            const teamName = user?.teamName || t('Unassigned');
            if (!groups[teamName]) groups[teamName] = { teamName, members: [] };
            groups[teamName].members.push(user);
            return groups;
        }, {})
    ).map((group) => {
        const moduleCounts = {};
        const activeMembers = group.members.filter((member) => member?.isActive);
        activeMembers.forEach((member) => {
            (member?.effectiveModules || []).forEach((key) => {
                moduleCounts[key] = (moduleCounts[key] || 0) + 1;
            });
        });
        return {
            ...group,
            activeMembers: activeMembers.length,
            availableModules: Object.keys(moduleCounts),
            allMemberModules: activeMembers.length ? Object.keys(moduleCounts).filter((key) => moduleCounts[key] === activeMembers.length) : []
        };
    });

    const moduleRows = (accessMatrix?.moduleCatalog || []).map((module) => {
        const allowedUsers = accessUsers.filter((user) => (user?.effectiveModules || []).includes(module.key));
        return {
            ...module,
            submodules: module.key === 'supply_dispatch' ? Object.entries(dispatchActionLabels).map(([key, label]) => ({ key, label })) : module.submodules,
            allowedUsers,
            deniedUsers: accessUsers.filter((user) => !(user?.effectiveModules || []).includes(module.key)),
            teams: Array.from(new Set(allowedUsers.map((user) => user?.teamName).filter(Boolean)))
        };
    });

    const accessSourceTemplate = (row) => {
        const source = row?.source || 'default-deny';
        const severity = source === 'user-override' ? 'warning' : source === 'account-status' ? 'danger' : source === 'team' || source === 'special-rule' ? 'info' : source === 'role' ? 'success' : null;
        return <Tag value={row?.sourceLabel || source} severity={severity} />;
    };

    const moduleAccessDetailTemplate = (module) => (
        <div className="p-3">
            {(module?.submodules || []).length ? (
                <DataTable value={module.submodules} className="p-datatable-sm" responsiveLayout="scroll">
                    <Column field="label" header={t('Submodule / action')} />
                    <Column field="key" header={t('Permission key')} />
                    <Column header={t('Access')} body={(row) => <Tag value={row?.allowed ? t('Allowed') : t('Denied')} severity={row?.allowed ? 'success' : 'danger'} />} />
                    <Column header={t('Source')} body={accessSourceTemplate} />
                </DataTable>
            ) : (
                <div className="text-color-secondary">{t('This module currently has one module-level permission.')}</div>
            )}
        </div>
    );

    const teamExpansionTemplate = (team) => (
        <div className="p-3">
            <DataTable value={team.members} className="p-datatable-sm" responsiveLayout="scroll">
                <Column header={t('User')} body={(row) => `${row?.firstName || ''} ${row?.lastName || ''}`.trim()} />
                <Column field="roleTitle" header={t('Role')} />
                <Column header={t('Status')} body={(row) => <Tag value={row?.isActive ? t('Active') : t('Inactive')} severity={row?.isActive ? 'success' : 'danger'} />} />
                <Column header={t('Allowed modules')} body={(row) => (row?.effectiveModules || []).join(', ') || '-'} />
                <Column header={t('Access type')} body={(row) => <Tag value={row?.accessType || '-'} severity={row?.accessType === 'custom' ? 'warning' : row?.accessType === 'disabled' ? 'danger' : 'info'} />} />
            </DataTable>
        </div>
    );

    const moduleExpansionTemplate = (module) => (
        <div className="p-3">
            <div className="mb-3">
                <strong>{t('Submodules and actions')}</strong>
                <ul className="mt-2 mb-0">
                    {(module?.submodules || []).map((submodule) => <li key={submodule.key}>{submodule.label} <span className="text-color-secondary">({submodule.key})</span></li>)}
                    {!(module?.submodules || []).length ? <li>{t('Module-level access only')}</li> : null}
                </ul>
            </div>
            <DataTable value={module.allowedUsers} className="p-datatable-sm" responsiveLayout="scroll" emptyMessage={t('No users have access')}>
                <Column header={t('User')} body={(row) => `${row?.firstName || ''} ${row?.lastName || ''}`.trim()} />
                <Column field="roleTitle" header={t('Role')} />
                <Column field="teamName" header={t('Team')} />
                <Column header={t('Source')} body={(row) => {
                    const detail = (row?.accessDetails || []).find((item) => item.key === module.key);
                    return accessSourceTemplate(detail || {});
                }} />
            </DataTable>
        </div>
    );
    return (
        <div className="p-4">
            <Dialog header={<div>{editable ? t('Edit User') : viewable ? t('View User') : t('Add User')}</div>} visible={showAddDialog} onHide={onClose} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} draggable={false}>
                <AddEditUser rowRecord={rowRecord} editable={editable} viewable={viewable} onHide={onHide} onClose={onClose} />
            </Dialog>

            <ActiveInactiveDialog visible={switchModal} onHide={handleSwitchModalClose} onConfirm={handleInputSwitch} onCancel={handleSwitchModalClose} status={switchData?.isActive} />
            <Dialog
                header={t('Edit Module Access')}
                visible={accessDialogVisible}
                onHide={closeAccessDialog}
                style={{ width: '42rem' }}
                breakpoints={{ '960px': '90vw', '640px': '100vw' }}
                draggable={false}
            >
                <div className="mb-2">
                    <strong>{`${accessDialogUser?.firstName || ''} ${accessDialogUser?.lastName || ''}`.trim()}</strong>
                    <div className="text-sm text-color-secondary">{accessDialogUser?.email || '-'}</div>
                </div>
                <div className="mb-3">
                    <label className="block mb-2">{t('Modules')}</label>
                    <MultiSelect
                        value={selectedModules}
                        options={accessOptions(accessMatrix?.moduleCatalog || [])}
                        onChange={(e) => {
                            const changed = changeAccessSelection(selectedModules, e.value);
                            setSelectedModules(changed.selection);
                            if (changed.dispatchChanged) setDispatchAccessChanged(true);
                        }}
                        filter
                        className="w-full"
                        maxSelectedLabels={5}
                        placeholder={t('Select modules')}
                    />
                    <small className="block mt-2 text-color-secondary">
                        {t('An empty selection uses the role default. Select one or more modules to create a custom override.')}
                    </small>
                </div>
                <div className="flex gap-2 justify-content-end">
                    <Button
                        type="button"
                        label={t('Reset To Role Default')}
                        className="p-button-secondary"
                        onClick={resetAccessToRole}
                    />
                    <Button type="button" label={t('Save')} onClick={saveAccessDialog} />
                </div>
            </Dialog>

            <Dialog
                header={t('Effective access details')}
                visible={Boolean(accessDetailUser)}
                onHide={() => {
                    setAccessDetailUser(null);
                    setExpandedAccessRows(null);
                }}
                style={{ width: '72rem' }}
                breakpoints={{ '1100px': '92vw', '640px': '100vw' }}
                draggable={false}
            >
                <div className="flex flex-wrap justify-content-between gap-3 mb-3">
                    <div>
                        <strong>{`${accessDetailUser?.firstName || ''} ${accessDetailUser?.lastName || ''}`.trim()}</strong>
                        <div className="text-sm text-color-secondary">{accessDetailUser?.email || '-'}</div>
                    </div>
                    <div className="flex gap-2 align-items-center">
                        <Tag value={accessDetailUser?.isActive ? t('Active') : t('Inactive')} severity={accessDetailUser?.isActive ? 'success' : 'danger'} />
                        <Tag value={accessDetailUser?.roleTitle || accessDetailUser?.roleUid || '-'} severity="info" />
                        <Tag value={accessDetailUser?.teamName || t('Unassigned')} />
                    </div>
                </div>
                <DataTable
                    value={accessDetailUser?.accessDetails || []}
                    rowExpansionTemplate={moduleAccessDetailTemplate}
                    expandedRows={expandedAccessRows}
                    onRowToggle={(event) => setExpandedAccessRows(event.data)}
                    dataKey="key"
                    responsiveLayout="scroll"
                    className="p-datatable-sm"
                >
                    <Column expander style={{ width: '3rem' }} />
                    <Column field="label" header={t('Module')} />
                    <Column field="key" header={t('Permission key')} />
                    <Column field="route" header={t('Route')} />
                    <Column header={t('Access')} body={(row) => <Tag value={row?.allowed ? t('Allowed') : t('Denied')} severity={row?.allowed ? 'success' : 'danger'} />} />
                    <Column header={t('Source')} body={accessSourceTemplate} />
                </DataTable>
            </Dialog>

            <div className="flex justify-content-between align-items-center mb-3">
                <h3>{t('System Users')}</h3>

                {/* <div className="flex gap-2">{permissionsList?.insertAllowed === 'Y' && <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => handleAdd()} />}</div> */}
                <div className="flex gap-2">
                    <ImpersonateUser />
                    <Button
                        label={t('Add New')}
                        icon="pi pi-plus"
                        className="p-button-success p-button-sm"
                        tooltip={t('Add a new user')}
                        tooltipOptions={{ position: 'top' }}
                        onClick={() => handleAdd()}
                    />
                </div>
            </div>

            <DataTable
                paginator
                rows={15}
                rowsPerPageOptions={[5, 10, 20]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate={t('Showing {first} to {last} of {totalRecords} Records')}
                emptyMessage={t('No List found.')}
                responsiveLayout="scroll"
                value={allUsers}
                className="p-datatable-sm datatable-responsive"
            >
                {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column> */}
                {/* <Column field="id" header="SL" body={(rowData, options) => options.rowIndex + 1} style={{ width: '60px' }} /> */}
                <Column field="firstName" header={t('First Name')} />
                <Column field="lastName" header={t('Last Name')} />
                <Column field="role.title" header={t('Role')} />
                <Column 
                    header={t('Team')} 
                    body={(rowData) => {
                        if (rowData.team && typeof rowData.team === 'object') {
                            return rowData.team.name || '-';
                        }
                        return '-';
                    }}
                />
                <Column field="email" header={t('Email')} />
                <Column field="whatsApp" header={t('Phone')} />
                <Column body={statusBodyTemplate} header={t('Status')} />
                <Column header={t('Actions')} body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>

            <Card title={t('Access Explorer')} className="mt-4">
                <div className="flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
                    <div className="text-color-secondary">
                        {t('Effective access includes role defaults, team rules, user overrides, special rules, and account status.')}
                    </div>
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText value={accessSearch} onChange={(event) => setAccessSearch(event.target.value)} placeholder={t('Search users, roles, or teams')} />
                    </span>
                </div>
                {accessLoadError ? <div className="mb-3 text-red-500">{accessLoadError}</div> : null}
                <TabView>
                    <TabPanel header={t('Users')}>
                        <DataTable value={filteredAccessUsers} paginator rows={10} rowsPerPageOptions={[10, 20, 50]} responsiveLayout="scroll" className="p-datatable-sm" dataKey="_id">
                            <Column header={t('User')} body={(row) => <div><strong>{`${row?.firstName || ''} ${row?.lastName || ''}`.trim()}</strong><div className="text-sm text-color-secondary">{row?.email || '-'}</div></div>} />
                            <Column header={t('Status')} body={(row) => <div className="flex gap-1 flex-wrap"><Tag value={row?.isActive ? t('Active') : t('Inactive')} severity={row?.isActive ? 'success' : 'danger'} />{row?.isHiddenFromLists ? <Tag value={t('Hidden')} severity="warning" /> : null}{row?.isProtected ? <Tag value={t('Protected')} severity="info" /> : null}</div>} />
                            <Column field="roleTitle" header={t('Role')} />
                            <Column field="teamName" header={t('Team')} />
                            <Column header={t('Allowed')} body={(row) => <Tag value={String((row?.effectiveModules || []).length)} severity="success" />} />
                            <Column header={t('Denied')} body={(row) => <Tag value={String((row?.deniedModules || []).length)} severity="danger" />} />
                            <Column header={t('Access type')} body={(row) => <Tag value={row?.accessType || '-'} severity={row?.accessType === 'custom' ? 'warning' : row?.accessType === 'disabled' ? 'danger' : 'info'} />} />
                            <Column header={t('Special access')} body={(row) => (row?.specialAccess || []).join(', ') || '-'} />
                            <Column header={t('Actions')} body={(row) => <div className="flex gap-2"><Button type="button" icon="pi pi-eye" className="p-button-rounded p-button-sm p-button-info" onClick={() => setAccessDetailUser(row)} tooltip={t('Explain access')} /><Button type="button" icon="pi pi-pencil" className="p-button-rounded p-button-sm" onClick={() => openAccessDialog(row)} tooltip={t('Edit module access')} disabled={row?.isProtected && currentRoleUid !== 'superAdmin'} /></div>} />
                        </DataTable>
                    </TabPanel>
                    <TabPanel header={t('Teams')}>
                        <DataTable value={teamRows} dataKey="teamName" expandedRows={expandedTeamRows} onRowToggle={(event) => setExpandedTeamRows(event.data)} rowExpansionTemplate={teamExpansionTemplate} responsiveLayout="scroll" className="p-datatable-sm">
                            <Column expander style={{ width: '3rem' }} />
                            <Column field="teamName" header={t('Team')} />
                            <Column header={t('Members')} body={(row) => row.members.length} />
                            <Column field="activeMembers" header={t('Active members')} />
                            <Column header={t('Available to at least one member')} body={(row) => row.availableModules.join(', ') || '-'} />
                            <Column header={t('Available to every active member')} body={(row) => row.allMemberModules.join(', ') || '-'} />
                        </DataTable>
                    </TabPanel>
                    <TabPanel header={t('Modules & Submodules')}>
                        <DataTable value={moduleRows} dataKey="key" expandedRows={expandedModuleRows} onRowToggle={(event) => setExpandedModuleRows(event.data)} rowExpansionTemplate={moduleExpansionTemplate} responsiveLayout="scroll" className="p-datatable-sm">
                            <Column expander style={{ width: '3rem' }} />
                            <Column field="label" header={t('Module')} />
                            <Column field="key" header={t('Permission key')} />
                            <Column field="route" header={t('Route')} />
                            <Column header={t('Submodules / actions')} body={(row) => (row?.submodules || []).length} />
                            <Column header={t('Users allowed')} body={(row) => <Tag value={String(row.allowedUsers.length)} severity="success" />} />
                            <Column header={t('Users denied')} body={(row) => <Tag value={String(row.deniedUsers.length)} severity="danger" />} />
                            <Column header={t('Teams with access')} body={(row) => row.teams.join(', ') || '-'} />
                        </DataTable>
                    </TabPanel>
                    <TabPanel header={t('Rules & Audit')}>
                        <div className="grid">
                            <div className="col-12 lg:col-7">
                                <h5>{t('Role defaults')}</h5>
                                <DataTable value={Object.entries(accessMatrix?.roleMatrix || {}).map(([role, modules]) => ({ role, modules: (modules || []).join(', ') }))} responsiveLayout="scroll" className="p-datatable-sm">
                                    <Column field="role" header={t('Role')} />
                                    <Column field="modules" header={t('Modules')} />
                                </DataTable>
                            </div>
                            <div className="col-12 lg:col-5">
                                <h5>{t('Team rules')}</h5>
                                <DataTable value={Object.entries(accessMatrix?.teamMatrix || {}).map(([team, access]) => ({ team, allow: (access?.allow || []).join(', ') || '-', deny: (access?.deny || []).join(', ') || '-', special: (access?.specialAccess || []).join(', ') || '-' }))} responsiveLayout="scroll" className="p-datatable-sm">
                                    <Column field="team" header={t('Team')} />
                                    <Column field="allow" header={t('Adds')} />
                                    <Column field="deny" header={t('Removes')} />
                                    <Column field="special" header={t('Special')} />
                                </DataTable>
                            </div>
                            <div className="col-12">
                                <h5>{t('Invalid Role-Team Audit')}</h5>
                                <div className="mb-2"><strong>{t('Invalid combinations')}:</strong> {accessAudit?.invalidCount ?? 0}</div>
                                <DataTable value={accessAudit?.invalidUsers || []} responsiveLayout="scroll" className="p-datatable-sm">
                                    <Column header={t('User')} body={(row) => `${row?.firstName || ''} ${row?.lastName || ''}`.trim()} />
                                    <Column field="email" header={t('Email')} />
                                    <Column field="roleUid" header={t('Role UID')} />
                                    <Column field="teamName" header={t('Team')} />
                                    <Column header={t('Allowed Teams')} body={(row) => (row?.allowedTeams || []).join(', ')} />
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                </TabView>
            </Card>
        </div>
    );
};

export default Users;
